module.exports = __webpack_public_path__ + "static/alam01-25193be04dba408a817254b28d0215b0.jpg";